/* Colour dots on product tiles (snippets/sg-tile-dots.liquid).
   Mouse: hovering a dot shows that colour's photo; leaving the dots puts the
   tile photo back; clicking a dot opens that colour.
   Touch: first tap on a dot shows its photo and points the tile at it,
   a second tap on the same dot opens it.
   Fit: only as many dots as fit beside the price are shown; the rest
   become "+N" (on the Bases page they move to their own line and all show).
   Re-measured when the window size changes. */
(function () {
  var canHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;

  function tileOf(el) { return el.closest('.thumbnail'); }
  function imgOf(tile) { return tile && tile.querySelector('.product_image .image__container img'); }

  function show(dot) {
    var tile = tileOf(dot), img = imgOf(tile);
    if (!img || !dot.dataset.img) return;
    if (!img.hasAttribute('data-sg-src')) {
      img.setAttribute('data-sg-src', img.getAttribute('src') || '');
      img.setAttribute('data-sg-srcset', img.getAttribute('srcset') || '');
    }
    img.removeAttribute('srcset');
    img.src = dot.dataset.img;
    tile.querySelectorAll('.sg-dot').forEach(function (d) { d.classList.toggle('is-on', d === dot); });
  }

  function restore(tile) {
    var img = imgOf(tile);
    if (img && img.hasAttribute('data-sg-src')) {
      var set = img.getAttribute('data-sg-srcset');
      if (set) img.setAttribute('srcset', set);
      img.src = img.getAttribute('data-sg-src');
    }
    tile.querySelectorAll('.sg-dot.is-on').forEach(function (d) { d.classList.remove('is-on'); });
  }

  function fit(box) {
    var details = box.parentElement, price = details && details.querySelector('.price');
    var dots = box.querySelectorAll('.sg-dot'), more = box.querySelector('.sg-dots__more');
    if (!details || !dots.length) return;
    var total = parseInt(more && more.getAttribute('data-sg-total'), 10) || dots.length;
    dots.forEach(function (d) { d.style.display = ''; });
    // The price box stretches to fill the line, so measure only its text.
    var priceW = 0;
    if (price) price.querySelectorAll('.current_price, .was_price').forEach(function (el) {
      var r = document.createRange(); r.selectNodeContents(el); priceW += r.getBoundingClientRect().width + 4;
    });
    var avail = details.clientWidth - priceW - 12;
    var step = 20, moreW = 26;
    var n = Math.floor(avail / step);
    if (n < total) n = Math.max(1, Math.floor((avail - moreW) / step));
    n = Math.min(n, dots.length);
    // Bases page: when the colours do not all fit beside the price, the dots get their own line under it and all of them show.
    box.classList.remove('sg-dots--row');
    if (n < total && box.closest('[data-sg-types]')) { box.classList.add('sg-dots--row'); n = dots.length; }
    dots.forEach(function (d, i) { if (i >= n) d.style.display = 'none'; });
    if (more) {
      var rest = total - n;
      var txt = '+' + rest;
      if (more.textContent !== txt) more.textContent = txt; // a change here would re-trigger the observer
      if (rest > 0) more.removeAttribute('hidden'); else more.setAttribute('hidden', '');
    }
  }
  function fitAll() { document.querySelectorAll('[data-sg-dots]').forEach(fit); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fitAll); else fitAll();
  window.addEventListener('load', fitAll);
  var t; window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(fitAll, 150); });
  document.addEventListener('shopify:section:load', fitAll);
  new MutationObserver(function (m) {
    for (var i = 0; i < m.length; i++) if (m[i].addedNodes.length) { clearTimeout(t); t = setTimeout(fitAll, 50); break; }
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (canHover) {
    document.addEventListener('mouseover', function (e) {
      var dot = e.target.closest && e.target.closest('.sg-dot');
      if (dot) show(dot);
    });
    document.addEventListener('mouseout', function (e) {
      var dots = e.target.closest && e.target.closest('[data-sg-dots]');
      if (!dots) return;
      if (e.relatedTarget && dots.contains(e.relatedTarget)) return;
      restore(tileOf(dots));
    });
  }

  function open(dot) { if (dot.dataset.href) window.location.href = dot.dataset.href; }

  document.addEventListener('click', function (e) {
    var dot = e.target.closest && e.target.closest('.sg-dot');
    if (!dot) return;
    e.preventDefault();
    e.stopPropagation();
    if (!canHover && !dot.classList.contains('is-on')) {
      show(dot);
      tileOf(dot).querySelectorAll('a[href]').forEach(function (a) { a.setAttribute('href', dot.dataset.href); });
      return;
    }
    open(dot);
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var dot = e.target.closest && e.target.closest('.sg-dot');
    if (!dot) return;
    e.preventDefault();
    open(dot);
  });
})();
